// services/securityTransferService.js

import apiClient from "../api";

export const transferSecurity = async (command, isAdd = true) => {
  try {
    const endpoint = isAdd ? '/api/Transactions/add-security' : '/api/Transactions/transfert-security';
    const response = await apiClient.post(endpoint, command, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    // console.error(`Erreur lors du ${isAdd ? 'ajout' : 'retrait'} de titres:`, error);
    throw error.response?.data?.message || `Échec du ${isAdd ? 'ajout' : 'retrait'} de titres`;
  }
};

export const getPublicSecuritiesOptions = async (domainId) => {
  try {
    const response = await apiClient.get(`/api/Security/All/Security/Public/${domainId}`);
    
    if (Array.isArray(response.data)) {
      return response.data.map(security => ({
        value: security.id,
        label: security.name || security.code || `Titre #${security.id}`,
        original: security,
      }));
    }
    
    // Si structure paginée
    return (response.data.items || []).map(security => ({
      value: security.id,
      label: security.name || security.code || `Titre #${security.id}`,
      original: security,
    }));
  } catch (error) {
    // console.error('Erreur lors de la récupération des titres:', error);
    return [];
  }
};